import React, { Component } from "react";
import PropTypes from "prop-types";
import { Field } from "redux-form";
import { Card, CardContent, Grid, Paper } from "@material-ui/core";
import { renderSelectField6 } from "../../form-global-components/components-form-components-for-react-final-form";
import { ButtonChangeProgram } from "theme";
class FormFieldsTabProgramsTabPrograms extends Component {
  confirmBeforeChange = () => {
    var answer = window.confirm("Confirm you want to Change Programs?");
    if (answer) {
      this.props.handleSubmitChangeProgram();
    }
  };
  render() {
    // console.log('rr-tt this.props = ', this.props);
    return (
      <div>
        <Paper>
          <Card>
            <CardContent>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Field
                    component={renderSelectField6}
                    id="program"
                    name="program"
                    label="Programs List"
                    locked={this.props.locked}
                    onChange={this.props.changeProgram}
                    autoFocus
                    dataArray={this.props.programsList.map((program) => ({
                      value: program.id,
                      label: program.description,
                    }))}
                  />
{/* 
                                                                                            <option value='0'>Select A Program</option>
                                                                                            {this.props.programsList.map((program, index) => {
                                                                                              return (
                                                                                                <option key={index} value={program.id}>
                                                                                                  {program.description}
                                                                                                </option>
                                                                                              )
                                                                                            })}
*/}
                </Grid>
              </Grid>

              {this.props.allowChangeProgram ? (
                <>
                  <ButtonChangeProgram
                    size="large"
                    fullWidth
                    onClick={() => {this.confirmBeforeChange()}}
                    // onClick={this.props.handleSubmitChangeProgram}
                    disabled={!this.props.allowChangeProgram}
                  >
                    Change Program
                  </ButtonChangeProgram>

                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <span>
                        <ul>
                          <li>
                            This action will Archive this Client and copy this
                            Client back to the Referrals list as a new entry
                          </li>
                          <li>
                            The referral will now be available to select a new
                            program
                          </li>
                          <li>
                            All information on the Name tab will be copied over
                          </li>
                          <li>
                            All other Referral Tab details will need to be
                            reviewed and reentered
                          </li>
                        </ul>
                      </span>
                    </Grid>
                  </Grid>
                </>
              ) : (
                ""
              )}
            </CardContent>
          </Card>
        </Paper>
      </div>
    );
  }
}
FormFieldsTabProgramsTabPrograms.propTypes = {
  locked: PropTypes.bool,
  allowChangeProgram: PropTypes.bool,
  programsList: PropTypes.array,
  /*** function provided by parent */
  changeProgram: PropTypes.func,
  handleSubmitChangeProgram: PropTypes.func,
};
export default FormFieldsTabProgramsTabPrograms;
